import classNames from 'classnames';
import React from 'react';
import TextField from '../../../../../../../Inputs/TextField';

import styles from '../index.module.scss';

// TODO: FIX TYPING
export default function ({
  updateSearchParams,
}: {
  updateSearchParams: ({ patientName }: { patientName: string }) => void;
}) {
  return (
    <>
      <div className={classNames('text-center font-semibold', styles.title)}>
        Enter the patient’s name
      </div>
      <TextField
        variant={'outlined'}
        wrapperClassName={styles.inputWrapper}
        inputClassName={styles.inputField}
        placeholder={'Full Name'}
        onChange={async (e) => updateSearchParams({ patientName: e.target.value })}
      />
    </>
  );
}
